"use client";

import { motion } from "framer-motion";

import Image from "@/app/_components/Image";
import { FIFA_ASSET_VERSION } from "@/constants/vars.constants";
import { DEFAULT_DURATION } from "@/lib/animation";

import styles from "./StayInspiredSection.module.scss";

const cards = [
  {
    title: "Australian Open",
    description:
      "Kia x Australian open, the value of movement beyond victory",
    image: `/fifa/financial_banner_1.webp?v=${FIFA_ASSET_VERSION}`,
    href: "https://worldwide.kia.com/en/brand/our-movement/partnership/australian-open/",
  },
  {
    title: "Social Impact",
    description: "Towards a sustainable tomorrow",
    image: `/fifa/financial_banner_2.webp?v=${FIFA_ASSET_VERSION}`,
    href: "https://worldwide.kia.com/en/brand/our-movement/social-impact/",
  },
  {
    title: "FIFA Official Match Ball Carrier",
    description:
      "The 49th team creating the opening moment of the FIFA World Cup 2026™",
    image: `/fifa/financial_banner_3.webp?v=${FIFA_ASSET_VERSION}`,
    href: "https://worldwide.kia.com/en/brand/brand-stories/official-match-ball-carrier/",
  },
];

export default function StayInspiredSection() {
  return (
    <section className={styles.section}>
      <div className={styles.card}>
        <motion.h2
          className={styles.title}
          initial={{
            opacity: 0,
            y: 40,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
            amount: 0.3,
          }}
          transition={{
            duration: DEFAULT_DURATION,
          }}
        >
          Stay Inspired
        </motion.h2>

        <div className={styles.grid}>
          {cards.map((item, index) => (
            <motion.a
              key={item.title}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.item}
              initial={{
                opacity: 0,
                y: 60,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
                amount: 0.2,
              }}
              transition={{
                duration: 0.7,
                delay: index * 0.1,
              }}
            >
              <div className={styles.imageWrap}>
                <Image
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  fill
                  className={styles.image}
                  sizes="(max-width: 768px) 100vw, 33vw"
                  loading="lazy"
                  quality={70}
                />
              </div>

              <div className={styles.textContent}>
                <h3>{item.title}</h3>

                <p>{item.description}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}